import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteSeo, toAbsoluteUrl } from '../lib/routeSeoPolicy';

function upsertMeta(name: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function removeMeta(name: string) {
  document.head.querySelector(`meta[name="${name}"]`)?.remove();
}

function upsertCanonical(href: string) {
  let tag = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
}

function removeCanonical() {
  document.head.querySelector('link[rel="canonical"]')?.remove();
}

export default function RouteSeoHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getRouteSeo(pathname);

    if (seo.title) {
      document.title = seo.title;
      upsertMeta('twitter:title', seo.title);
      let ogTitle = document.head.querySelector<HTMLMetaElement>('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute('content', seo.title);
    }

    if (seo.description) {
      upsertMeta('description', seo.description);
      upsertMeta('twitter:description', seo.description);
      let ogDescription = document.head.querySelector<HTMLMetaElement>('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.setAttribute('content', seo.description);
    }

    if (seo.canonicalPath) {
      upsertCanonical(toAbsoluteUrl(seo.canonicalPath));
    } else {
      removeCanonical();
    }

    if (seo.noindex) {
      upsertMeta('robots', 'noindex,follow');
    } else {
      removeMeta('robots');
    }
  }, [pathname]);

  return null;
}
